import MarkdownText from './MarkdownText'

// Renders a quest's objectives/steps. Read-only by default (used in the player
// view and the preview card — only active/done steps are shown). When
// `editable` + `onSetStatus` are passed (admin), every step is shown with an
// inline Hidden/Active/Done toggle for live updates during a session.
//
// Step text supports [[wiki-links]] (rendered via MarkdownText), which inherit
// fog of war — a link to a hidden entity degrades to muted text for players.

const STATUS_META = {
  hidden: { icon: '◌', color: 'var(--text-muted)' },
  active: { icon: '▸', color: 'var(--accent-cyan)' },
  done: { icon: '✓', color: '#27ae60' },
}

const STATUSES = [
  { key: 'hidden', label: 'Hide' },
  { key: 'active', label: 'Active' },
  { key: 'done', label: 'Done' },
]

export function parseSteps(value) {
  if (!value) return []
  try {
    const parsed = JSON.parse(value)
    return Array.isArray(parsed) ? parsed : []
  } catch {
    return []
  }
}

export default function QuestSteps({ steps, editable = false, onSetStatus }) {
  const list = Array.isArray(steps) ? steps : []
  const hasVisible = editable ? list.length > 0 : list.some((s) => s.status !== 'hidden')
  if (!hasVisible) return null

  return (
    <div>
      <div style={{ textTransform: 'uppercase', letterSpacing: '0.08em', fontSize: '0.75rem', fontWeight: 700, color: 'var(--accent-cyan)', marginBottom: '0.6rem' }}>
        Objectives
      </div>
      <div style={{ display: 'flex', flexDirection: 'column', gap: '0.5rem' }}>
        {list.map((step, i) => {
          if (!editable && step.status === 'hidden') return null
          const meta = STATUS_META[step.status] || STATUS_META.active
          return (
            <div key={i} style={{ display: 'flex', alignItems: 'center', gap: '0.6rem', flexWrap: 'wrap' }}>
              <span style={{ color: meta.color, fontWeight: 700, width: '1rem', textAlign: 'center' }}>{meta.icon}</span>
              <span style={{ flex: 1, minWidth: '160px' }}>
                <MarkdownText
                  style={{
                    color: step.status === 'done' ? 'var(--text-muted)' : 'var(--text-secondary)',
                    textDecoration: step.status === 'done' ? 'line-through' : 'none',
                  }}
                >
                  {step.text}
                </MarkdownText>
              </span>
              {editable && onSetStatus && (
                <span style={{ display: 'flex', gap: '0.25rem' }}>
                  {STATUSES.map((s) => {
                    const active = step.status === s.key
                    return (
                      <button
                        key={s.key}
                        onClick={() => onSetStatus(i, s.key)}
                        style={{
                          background: active ? 'var(--accent-teal)' : 'var(--accent-deep)',
                          color: active ? '#06121a' : 'var(--text-muted)',
                          border: '1px solid var(--accent-teal)',
                          borderRadius: '4px',
                          padding: '0.2rem 0.5rem',
                          fontSize: '0.7rem',
                          fontWeight: 600,
                          cursor: 'pointer',
                        }}
                      >
                        {s.label}
                      </button>
                    )
                  })}
                </span>
              )}
            </div>
          )
        })}
      </div>
    </div>
  )
}
